import * as React from 'react'
import MaterialCard from '@mui/material/Card'
import CardHeader from '@mui/material/CardHeader'
import CardContent from '@mui/material/CardContent'
import Box from '@mui/material/Box'
import { Typography } from '@mui/material'

import Tooltip from 'components/Shared/Tooltip'
import styles from 'components/Shared/Card/Card.module.scss'
import MoreVertActions from 'components/Shared/MoreVertActions'

type MoreVertActionsProps = {
  moreVertOptions: Array<string>
  moreVertRef: React.RefObject<HTMLDivElement>
  fileNameKey: string
}

type Props = {
  cardSizeClass?: string
  header?: string
  subheader?: string
  content: any
  info: string | HTMLElement | JSX.Element
  showMoreAction?: boolean
  topContentSpacing?: 'default' | 'none' | undefined
  moreVertProps?: MoreVertActionsProps
  isLoading: boolean
  subHeaderContent?: JSX.Element
} & typeof defaultProps

const defaultProps = {
  cardSizeClass: 'default-size',
  showMoreAction: true,
  info: '',
  topContentSpacing: 'default',
  isLoading: false,
}

const Card = (props: Props) => {
  const {
    cardSizeClass,
    header,
    subheader,
    content,
    showMoreAction,
    info,
    topContentSpacing,
    moreVertProps,
    subHeaderContent,
  } = props

  const cardHeaderContent = () => {
    const {
      moreVertOptions = [''],
      moreVertRef,
      fileNameKey = '',
    } = moreVertProps || {}

    return (
      <>
        {subHeaderContent}
        {showMoreAction ? (
          <>
            {moreVertProps && (
              <MoreVertActions
                moreVertOptions={moreVertOptions}
                reference={moreVertRef}
                fileNameKey={fileNameKey}
              />
            )}
          </>
        ) : (
          <Box
            className={
              showMoreAction
                ? `${styles.cardHeaderPadding}`
                : `${styles.cardHeaderPaddingForEmptyContent}`
            }
          />
        )}
      </>
    )
  }

  return (
    <Box>
      <MaterialCard className={`${styles.container} ${styles[cardSizeClass]}`}>
        <Box ref={moreVertProps?.moreVertRef} className={`${styles.cardBox}`}>
          <CardHeader
            className={
              showMoreAction
                ? `${styles.cardHeaderPadding}`
                : `${styles.cardHeaderPaddingForEmptyContent}`
            }
            action={cardHeaderContent()}
            subheaderTypographyProps={{
              variant: 'caption',
            }}
            title={
              header && (
                <Typography variant="body1">
                  {header}{' '}
                  <Tooltip
                    info={
                      <span dangerouslySetInnerHTML={{ __html: info }}></span>
                    }
                  />
                </Typography>
              )
            }
            subheader={subheader}
          />
          <CardContent
            className={`${styles.cardContentPadding} ${
              styles[`contentTopSpacing_${topContentSpacing}`]
            }`}
          >
            {content}
          </CardContent>
        </Box>
      </MaterialCard>
    </Box>
  )
}

Card.defaultProps = defaultProps

export default Card
